var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from 'react';
import { Footnote } from '@telus-uds/components-web';
import { richTextWithPlainString } from '../../../helpers/richText';
import LegalContext from '../store/legal-context';
var LegalLinksDrawer = function () {
    var _a = useContext(LegalContext), legalList = _a.legalList, openLegal = _a.openLegal, handleLegalClose = _a.handleLegalClose, language = _a.language, dictionary = _a.dictionary;
    return legalList.map(function (legal, index) { return (_jsx(Footnote, __assign({ copy: language, number: index + 1, isOpen: openLegal === index + 1, onClose: handleLegalClose, content: richTextWithPlainString(legal.content) }, (dictionary !== null && dictionary !== void 0 ? dictionary : { dictionary: dictionary })), index.toString())); });
};
LegalLinksDrawer.displayName = 'LegalLinksDrawer';
export default LegalLinksDrawer;
